
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { StandaloneIFrame } from 'components/StandaloneIFrame'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Aerosolembed } from 'components/aerosolembed'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Das kommt auf die Grösse an. Wenn das Teilchen gross ist, sinkt es durch die
  Schwerkraft relativ schnell ab; wenn es klein ist – typischerweise fünf
  Mikrometer und kleiner –, bewegt es sich mit der Luft. In Innenräumen dauert
  es sehr lange, bis solche Partikel auf dem Boden landen. Die Konzentration
  nimmt allerdings nach Stunden deutlich ab, aber ein Teil kann auch bis einen
  Tag oder sogar Tage in der Luft bleiben. Doch Sars-CoV-2
  wird womöglich nicht so lange infektiös bleiben, wie die Aerosole in der Luft
  sind. Mehrere Studien (<Link href='https://www.nejm.org/doi/full/10.1056/nejmc2004973' allowWordWrap mdxType="Link">hier</Link>, <Link href='https://www.tandfonline.com/doi/full/10.1080/22221751.2020.1777906' allowWordWrap mdxType="Link">hier</Link> und <Link href='https://academic.oup.com/jid/article/222/4/564/5856149' allowWordWrap mdxType="Link">hier</Link>) haben gezeigt, dass bei normaler
  Raumtemperatur das Virus 1 bis 2 Stunden aktiv bleibt. Wenn man also am Morgen
  ein Büro betrittt, wird es keine gefährlichen Aerosole mehr in der Luft haben.
  Darum ist es wohl auch besser, sich morgens statt abends in Räumen wie Läden,
  Apotheken etc. aufzuhalten.
    </p>
    <Aerosolembed mdxType="Aerosolembed" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;